import { useEffect, useState } from 'react';

/** Поля, над которыми телефон открывает экранную клавиатуру. */
const TEXT_TYPES = new Set(['text', 'search', 'email', 'password', 'number', 'tel', 'url']);

function isTextField(el: Element | null): boolean {
  if (el instanceof HTMLTextAreaElement) return !el.readOnly;
  if (el instanceof HTMLInputElement) return TEXT_TYPES.has(el.type) && !el.readOnly;
  return el instanceof HTMLElement && el.isContentEditable;
}

/**
 * Открыта ли экранная клавиатура: фокус в текстовом поле на сенсорном экране. По высоте окна не понять — на Android
 * со `resizes-content` сжимается сама раскладка, а iOS её не сжимает вовсе. Пока клавиатура открыта, панель вкладок
 * прячется (2026-10-23): иначе на Android она висела бы над клавиатурой, а на iOS строка создания на «Словах и
 * модулях» поднималась бы над клавиатурой с зазором в высоту панели.
 */
export function useSoftKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const coarse = window.matchMedia('(pointer: coarse)');
    let frame = 0;
    // focusout приходит, пока фокус ещё не переехал, — проверяем на следующем кадре.
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setOpen(coarse.matches && isTextField(document.activeElement)));
    };
    update();
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);
  return open;
}
